<style lang="scss" src='./Summary.scss' scoped></style>
<template src="./Summary.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters 
  } from "vuex";

  import moment from 'moment';

  export default {
    name: "Summary",
    components: {},
    data() {
      return {
        selected: null,
        amount: null,
        notes: null,
        complete: false,
        loading: false,
        coupon: null,
        showCouponValidation: false,
        loadingValidateCoupon: false
      };
    },
    computed: {
      ...mapState('CartStore', ['paymentMethods', 'cartProducts']),
      ...mapState(['cart_notes']),
      ...mapGetters("Main", ['getCouponsList']),
      ...mapState("Main", ['categorysList', 'coupons']),

      paymentMethodsList() {
        return this.paymentMethods.map(method => {
          return {
            ...method,
            title: this.$t('general.' + method.type)
          };
        });
      },

      showDiscount() {
        return this.cartProducts.coupon && this.cartProducts.discount > 0;
      },
    },
    watch: {
      cart_notes: {
        handler: function (value) {
          this.notes = value;
        },
        deep: true,
      },
      cartProducts: {
        handler: function (value) {
          if(value){
            this.coupon = value.coupon_id;
          }else{
            this.coupon = null;
          }
        },
        deep: true,
      },
      coupons: {
        handler: function (value) {
          if(value.length){
            this.setCouponsModal(true);
          }
        },
        deep: true,
      },
    },
    methods: {
      ...mapActions('CartStore', ['fnApiPaymentMethods', 'fnApiSetPaymentMethod', 'fnApiAddCoupon', 'fnApiRemoveCoupon']),
      ...mapMutations('CartStore', ['setVisibility']),
      ...mapMutations(["setCartNotes", 'setCouponsModal', 'setIsCheckout']),
      ...mapActions('Main', ['fnApiGetAvailableCoupons']),

      async fnValidate() {
        if (await this.$refs['formPayment'].validate()) {
          let tempBody = {
            type: this.selected
          };
          this.selected == 'CASH' && (tempBody.amount = this.amount);
          this.notes && (tempBody.notes = this.notes);
          this.loading = true;
          await this.fnApiSetPaymentMethod(tempBody);
          this.loading = false;
        }else{
          this.$notify({
                  text: this.$t('validations.requiredFieldsNotice'),
                  type: 'error',
                });
        }
      },


      fnGetDate(date) {
        return this.F_capitalizeAllFirst(this.F_formatDeliveryDate(date));
      },
      fnGetDateTime(dateTime) {
        return moment(dateTime, 'hh:mm:ss').format('hh:mm A');
      },

      fnUpdateCartNotes() {
        this.setCartNotes(this.notes);
      },

      fnSetCoupon() {
        if(this.coupon == null || this.coupon.trim().length == 0){
          return false;
        }
        this.coupon = this.coupon.trim().toUpperCase();
      },

      fnSelectCoupon() {
        if(this.coupon == null || this.coupon.trim().length == 0){
          return false;
        }
        this.coupon = this.coupon.trim().toUpperCase();
        this.fnValidateCoupon();
      },

      async fnValidateCoupon() {
        this.showCouponValidation = false;
        if(this.coupon == null || this.coupon.trim().length == 0){
          this.showCouponValidation = true;
          return false;
        }

        let tempBody = {
          coupon: this.coupon.trim().toUpperCase()
        };
        this.loadingValidateCoupon = true;
        let coupon_added = await this.fnApiAddCoupon(tempBody);
        if(!coupon_added){
          this.coupon = null;
        }
        this.loadingValidateCoupon = false;
      },

      async fnRemoveCoupon() {
        this.coupon = null;
        await this.fnApiRemoveCoupon();
      },

      fnGetCouponDesc(coupon){
        return this.fnGetCouponAmount(coupon) + ' ' + this.$t('coupons.discountIn') + ' ' + this.fnGetCategoryDiscount(coupon)
      },

      fnGetCouponAmount(coupon){
        if(coupon && coupon.type){
          if(coupon.type == 'PERCENTAGE'){
            return coupon.amount + '%';
          }else{
            return this.F_formatPrice(coupon.amount);
          }
        }
        return false;
      },

      fnGetCategoryDiscount(coupon){
        if(coupon ){
          if(coupon.category_id){
            let cat = this.categorysList.find(x => x.category_id == coupon.category_id);
            return cat ? (this.$t('general.at') + ' ' + cat.label) : '';
          }else{
            return this.$t('coupons.inYourPurchase');
          }
        }
        return '';
      },

    },

    beforeCreate() {},
    created() {
      this.notes = this.cart_notes;
      this.coupon = this.cartProducts && this.cartProducts.coupon_id ? this.cartProducts.coupon_id : null;
      window.fbq('track', 'PageView');
    },
    mounted() {
      if (this.cartProducts.products.length == 0) {
        this.setIsCheckout(false);
        this.$router.push('/');
      } else {
        this.amount = this.cartProducts.total + (100 - (this.cartProducts.total % 100))
        this.setIsCheckout(true);
        this.fnApiPaymentMethods();
        this.fnApiGetAvailableCoupons();
      }
    },
    beforeDestroy() {},
  };

</script>
